import React, { useState, useEffect } from "react";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import WaterMark from "../DashboardMain/WaterMark";

export default function ChartComponent(props) {

  useEffect(() => {

    if (props.selected !== "") {
      var root = am5.Root.new(props.chartId);

      root.setThemes([
        am5themes_Animated.new(root)
      ]);

      var chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: true,
          panY: true,
          wheelX: "panX",
          wheelY: "zoomX",
          pinchZoomX: true
        })
      );

      var cursor = chart.set(
        "cursor",
        am5xy.XYCursor.new(root, {
          behavior: "none"
        })
      );
      cursor.lineY.set("visible", false);

      var date = new Date();
      date.setHours(0, 0, 0, 0);
      var value = 100;

      // function generateData() {
      //   value = Math.round(Math.random() * 10 - 5 + value);
      //   am5.time.add(date, "day", 1);
      //   return { date: date.getTime(), value: value };
      // }

      // function generateDatas(count) {
      //   var data = [];
      //   for (var i = 0; i < count; ++i) {
      //     data.push(generateData());
      //   }
      //   return data;
      // }

      var xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          baseInterval: { timeUnit: props.dynamicInterval, count: 1 },
          // baseInterval: { timeUnit: "minute", count: 1 },
          // gridIntervals: [
          //   // { timeUnit: "day", count: 1 },
          //   { timeUnit: "minute", count: 1 },
          //   { timeUnit: "second", count: 1 }
          // ],
          renderer: am5xy.AxisRendererX.new(root, {}),
          tooltip: am5.Tooltip.new(root, {})
        })
      );
      xAxis.get("renderer").grid.template.set("forceHidden", true);
      xAxis.children.push(am5.Label.new(root, { text: "Date and Time", x: am5.p50, centerX: am5.p50 }));

      xAxis.get("dateFormats")["day"] = "yyyy-MM-dd HH:mm:ss"
      var yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {})
        })
      );

      yAxis.get("renderer").grid.template.set("forceHidden", true);
      yAxis.children.moveValue(am5.Label.new(root, { text: props.selected, rotation: -90, y: am5.p50, centerX: am5.p50 }), 0);

      var series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: "Series",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "value",
          valueXField: "date",
          tooltip: am5.Tooltip.new(root, {
            labelText: "{valueY}"
          })
        })
      );

      var scrollbar = chart.set(
        "scrollbarX",
        am5xy.XYChartScrollbar.new(root, {
          orientation: "horizontal",
          height: 60
        })
      );

      var sbDateAxis = scrollbar.chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          baseInterval: {
            timeUnit: "day",
            count: 1
          },
          renderer: am5xy.AxisRendererX.new(root, {})
        })
      );

      var sbValueAxis = scrollbar.chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {})
        })
      );

      var sbSeries = scrollbar.chart.series.push(
        am5xy.LineSeries.new(root, {
          valueYField: "value",
          valueXField: "date",
          xAxis: sbDateAxis,
          yAxis: sbValueAxis
        })
      );


      // var data = generateDatas(30);
      console.log("chartData", props.chartData);
      var data = props.chartData;
      series.data.setAll(data);
      sbSeries.data.setAll(data);

      series.appear(1000);
      chart.appear(1000, 100);

      root._logo.dispose();
      return () => root.dispose();

    }
  }, [props.chartData]);

  return (
    <>
      <WaterMark />
      <div id={props.chartId} style={{ width: "100%", height: "350px" }}></div>
    </>
  )
}
